import MazeTopPanel from './MazeTopPanel'

export default MazeTopPanel